(function oc_34_collection_v2() {
    let isMobile = window.matchMedia('(max-width:1023px)').matches;
    let slug = location.pathname;
    if (slug == '/collections/sneakers-mens' || slug == '/collections/womens-sneakers') {
        if (isMobile) {
            const URLS = {
                "/collections/sneakers-mens": {
                    img: "https://cdn-3.convertexperiments.com/uf/10041888/10042733/image 334 (1).jpg",
                    title: "The Low 1",
                    subtitle: "An iconic & timeless <br>low-top sneakers."
                },
                "/collections/womens-sneakers": {
                    img: "https://cdn-3.convertexperiments.com/uf/10041888/10042733/image 334 (1).jpg",
                    title: "The Low 1",
                    subtitle: "An iconic & timeless <br>low-top sneakers."
                },
                "/collections/low-1": {
                    img: "https://cdn-3.convertexperiments.com/uf/10041888/10042733/image 334 (2).jpg",
                    title: "The Low 1",
                    subtitle: "An iconic & timeless <br>low-top silhouette."
                },
                "/collections/low-1-women": {
                    img: "https://cdn-3.convertexperiments.com/uf/10041888/10042733/image 334 (2).jpg",
                    title: "The Low 1",
                    subtitle: "An iconic & timeless <br>low-top sneakers."
                }
            };
            let locName = location.pathname;
            let bannerData = URLS[locName] || null;
            if (bannerData != null && document.querySelector('#collection-root') && !document.querySelectorAll('.oc_34_collection_v2').length) {
                addBanner();
                document.body.classList.add('oc_34_collection_v2');
            } else if (!document.querySelectorAll('.oc_34_collection_v2').length) {
                requestAnimationFrame(oc_34_collection_v2);
            }
            function addBanner() {
                let collRoot = document.querySelector('#collection-root');
                if (collRoot && !document.querySelector('.oc_collBanner')) {
                    let sHtm = `
            <div class="oc_collBanner">
                <img src="${bannerData.img}" />
                <div class="oc_titleCard">
                    <h3>${bannerData.title}</h3>
                    <p>${bannerData.subtitle}</p>
                </div>
            </div>`;
                    collRoot.insertAdjacentHTML('afterbegin', sHtm);
                    if (location.pathname == '/collections/low-1' || location.pathname == '/collections/low-1-women') {
                        document.body.classList.add('oc_34_collection_lowOne');
                    }
                }
            }
        }
    }
})();